import { ProfileViewImage } from "../../../../core/components/ProfileViewImage";
import { TextComponent } from "../../../../core/components/TextComponent";
import { Column } from "../../../../core/components/Column";
import { CustomButton } from "../../../../core/components/CustomButton";
import ProfilePreview from "../../../profile/presentation/components/ProfilePreview";
import { Row } from "../../../../core/components/Row";
import { ButtonLikeDislike } from "../../../match/presentation/components/ButtonLikeDisLike";
import { LikeParams } from "../../../match/domain/entities/emitLikeParams";
import { Chats } from "../../../chat/domain/entities/getChat";
import { formatPublicProfileDistanceText } from "../../../../core/utilities/distance";
import { useSelector } from "react-redux";
import { RootState } from "../../../../core/store/store";

interface NotificationModalProps {
	modalState: { type: string; open: boolean };
	infoUser: LikeParams | undefined;
	handleCloseToast: () => void;
	handleChatClick: (chat: Chats, isFreeChat?: boolean) => void;
	handleLikeMatch: (type: "like" | "dislike") => void;
	rippleLike: boolean;
	rippleDislike: boolean;
}

export const ContentUserModal: React.FC<NotificationModalProps> = ({ modalState, infoUser, handleCloseToast, handleChatClick, handleLikeMatch, rippleLike, rippleDislike }) => {
	const { user } = useSelector((state: RootState) => state.onboarding);
	if (!infoUser) return null;

	return (
		<>
			{modalState.type === "match" && infoUser && (
				<>
					<div className="max-sm:hidden fixed top-0 left-0 z-30 h-screen w-full bg-[#00000099]" />
					<ProfileViewImage
						selectImage={infoUser.profile_pictures[0].url}
						handleIsSelected={handleCloseToast}
					>
						<TextComponent
							variant="big"
							className="text-white absolute max-sm:top-24 top-14 left-1/2 transform -translate-x-1/2 font-semibold"
							style={{ textShadow: "0px 3px 8px rgba(0, 0, 0, 1)" }}
						>
							It's a match
						</TextComponent>
						<Column className="w-full px-6 sm:px-12 absolute bottom-10 left-1/2 transform -translate-x-1/2">
							<CustomButton
								onClick={() => {
										handleChatClick(
											{
											chat_id: infoUser.match_id,
											user_id: infoUser.user_id,
											username: infoUser.username,
											profile_pictures: [infoUser.profile_pictures[0].url],
											message_sender_id: "",
											message_id: "",
											message_text: "",
											sent_at: "",
											read: false,
											show_last_logged: infoUser.show_last_logged,
											last_logged_in_time: infoUser.last_logged_in_time,
											unread_messages: 0,
											type: "text",
											status: "active",
											status_user_id1: "active",
												status_user_id2: "active",
											}
										);
								}}
							>
								Continue
							</CustomButton>
						</Column>
					</ProfileViewImage>
				</>
			)}
			{modalState.type === "like" && infoUser && (
				<div className="fixed top-0 left-0 z-30 h-screen w-full bg-[#0000006b]">
					<ProfilePreview
						pictures={infoUser.profile_pictures}
						username={infoUser.username}
						verify={infoUser.verify_status}
						bio={infoUser.bio}
						desires={infoUser.desires}
						interest={infoUser.interests}
						birth={infoUser.age}
						sexual_orientation={infoUser.sexual_orientation}
						marital_status={infoUser.marital_status}
						gender={infoUser.gender}
						location={infoUser.city}
						last_logged_in_time={infoUser.last_logged_in_time}
						show_last_logged={infoUser.show_last_logged}
						distance={formatPublicProfileDistanceText(infoUser.distance, {
							country: user?.country,
							city: user?.city,
						})}
						handleProfilePreview={handleCloseToast}
						partner={infoUser.partner}
						country={infoUser.country}
					>
						<Row
							mainAxisAlignment="around"
							crossAxisAlignment="center"
							className="sticky bottom-4 w-full"
						>
							<ButtonLikeDislike
								handleLikeMatch={handleLikeMatch}
								rippleLike={rippleLike}
								rippleDislike={rippleDislike}
							/>
						</Row>
					</ProfilePreview>
				</div>
			)}
		</>
	);
};
